<template>
  <div class="test-page">
    <div class="top">
      <div class="button" v-if="!sign" @click="Sign">
        <i class="calendar-icon"></i>
        <div class="but-text">去签到</div>
      </div>
      <div class="button" v-if="sign">
        <i class="calendar-icon"></i>
        <div class="but-text">已签到</div>
      </div>
      <div class="sign-in">已连续签到{{day}}天，继续加油!</div>
    </div>

    <div class="content">
      <!-- 年份 月份 -->
      <ul class="month bottom-line">
        <!--点击会触发pickpre函数，重新刷新当前日期 -->
        <!-- <li class="arrow" @click="pickPre(currentYear,currentMonth)">
          <van-icon name="arrow-left" />上个月
        </li>-->
        <li class="year-month">
          <span>{{ currentYear }}-{{ newMonth }}</span>
        </li>
        <!-- <li class="arrow" @click="pickNext(currentYear,currentMonth)">
          下个月
          <van-icon name="arrow" />
        </li>-->
      </ul>

      <!-- 星期 -->
      <ul class="weekdays">
        <li>日</li>
        <li>一</li>
        <li>二</li>
        <li>三</li>
        <li>四</li>
        <li>五</li>
        <li>六</li>
      </ul>

      <!-- 日期 -->
      <ul class="days bottom-line">
        <li v-for="(day,i) in days" :key="i">
          <!--本月已签到日期-->
          <span v-if="day.isSign && day.day.getMonth()+1 === currentMonth" class="cli">
            <img src="./img/1.png" />
            {{ day.day.getDate() }}
          </span>
          <!--本月未签到日期-->
          <span
            v-if="!day.isSign && day.day.getMonth()+1 === currentMonth"
            class="cli cli2"
            >
            <img v-if="day.day.getDate()==13 || day.day.getDate()==24"  src="./img/2.png" />
            {{ day.day.getDate() }}
            </span>
        </li>
      </ul>
    </div>

    <div class="role">
      <div class="role-title">签到规则</div>
      <div class="role-content" v-html="role ? role : '暂无内容'"></div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  // components: {
  // [Cell.name]: Cell,
  // [CellGroup.name]: CellGroup,
  // [Field.name]: Field,
  // [Popup.name]: Popup,
  // [Button.name]: Button,
  // [Icon.name]: Icon
  //   },
  data() {
    return {
      currentDay: 1, // 当前天
      currentMonth: 1, // 当前月
      newMonth:1,//当前月
      currentYear: 1970,
      currentWeek: 1, // 一号所在的星期
      days: [], // 当月所有天数
      content: {},
      arrDate: [], // 当月签到日期
      num: 0,
      day: 2,
      sign: false,
      role: '<p>您当前积分10，继续努力兑换奖品</p>'
    };
  },
  created() {
    this.getSign();
  },
  methods: {
    /**
     * 获取签到日期
     */
    getSign() {
      // 接口未完成，模拟数据
      const sign_days = [
        // { day: 5 }, { day: 1 }, { day: 2 }, { day: 3 }, { day: 4 }, { day: 6 }, { day: 7 }, { day: 8 }, { day: 9 }, { day: 10 }
        { day: 1 },{day: 2}
      ];
      for (const i in sign_days) {
        this.arrDate.push(sign_days[i].day);
      }
      this.initData(null);
    },
    initData(cur) {
      let date;
      if (cur) { // 切换日期
        date = new Date(cur);
      } else {
        var now = new Date();
        var d = new Date(this.formatDate(now.getFullYear(), now.getMonth() + 1, 1));
        d.setDate(35);// 设置天数为35天
        date = new Date(this.formatDate(d.getFullYear(), d.getMonth(), 1));
      }
      this.currentDay = date.getDate(); // 今日日期 几号
      this.currentYear = date.getFullYear(); // 当前年份
      this.currentMonth = date.getMonth() + 1; // 当前月份
      if(this.currentMonth.toString().length==1){ // 当前月份
        this.newMonth ='0'+this.currentMonth
      }else{
        this.newMonth = this.currentMonth
      }
      this.currentWeek = date.getDay(); // 0,1...6 星期
      const str = this.formatDate(this.currentYear, this.currentMonth, this.currentDay); // 2020-01-01
      this.days.length = 0; // 初始化日期
      // 如果今天是周日，放在第一行第7个位置，前面6个 这里默认显示一周，如果需要显示一个月，则第二个循环为 i<= 35- this.currentWeek
      for (var i = this.currentWeek; i > 0; i--) {
        const d = new Date(str);
        d.setDate(d.getDate() - i);
        var dayobject = {}; // 用一个对象包装Date对象  以便为以后预定功能添加属性
        dayobject.day = d;
        this.days.push(dayobject); // 将日期放入data 中的days数组 供页面渲染使用
      }
      // 其他周 // 设置天数为35天,周日设置在第一位，循环从36开始
      this.num = 0;
      for (var j = 0; j <= 36 - this.currentWeek; j++) {
        const d = new Date(str);
        d.setDate(d.getDate() + j);
        const dddd = d.getDate();
        if (dddd === 1) {
          this.num++;
        }
        if (this.num === 2) {
          return;
        }
        const dayobject = { day: d, isSign: this.isVerDate(dddd) };
        this.days.push(dayobject);
      }
    },
    /**
     * 判断该日期是否有签到
     * @param v
     * @returns {boolean}
     */
    isVerDate(v) {
      return this.arrDate.includes(v);
    },
    /**
     * 上一月
     * @param year
     * @param month
     */
    pickPre(year, month) {
      const d = new Date(this.formatDate(year, month, 1));
      d.setDate(0);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    /**
     * 下一月
     * @param year
     * @param month
     */
    pickNext(year, month) {
      const d = new Date(this.formatDate(year, month, 1));
      d.setDate(35);
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1));
    },
    // 返回 类似 2020-01-01 格式的字符串
    formatDate(year, month, day) {
      month < 10 && (month = '0' + month);
      day < 10 && (day = '0' + day);
      const data = year + '-' + month + '-' + day;
      return data;
    },
    /**
     * 点击签到
     * @param index
     */
    Sign() {
      const now = new Date();
      this.arrDate.push(now.getDate());
      this.initData();
      this.sign = true;
      // 接口待完成，虚拟提示
      Toast('签到成功');
    }
  }
}
</script>

<style lang="less" scoped>
.test-page {
  .top {
    width: 375px;
    height: 205.5px;
    background: url("./img/top-bg.png") no-repeat 0 0;
    background-size: 100% 100%;
    overflow: hidden;
    color: #ffffff;
    text-align: center;
    .button {
      display: flex;
      justify-content: center;
      border: 1px solid #ffffff;
      border-radius: 22px;
      font-size: 15px;
      width: 123px;
      margin: 53px auto 18px;
      height: 40.5px;
      align-items: center;
      .calendar-icon {
        display: block;
        width: 19.5px;
        height: 17.25px;
        background: url("./img/day-check.png") no-repeat 100%;
        background-size: 100% 100%;
      }
      .but-text {
        margin-left: 11.5px;
      }
    }
    .button:active {
      background-color: #5283c4;
      opacity: 0.8;
    }
    .sign-in {
      font-size: 12px;
      font-weight: lighter;
    }
  }

  .content {
    width: 347px;
    height: 326px;
    margin: auto;
    border-radius: 11px;
    overflow: hidden;
    margin-top: -48px;
    background: #ffffff;
    box-shadow: rgba(225, 225, 225, 0.7) 0 10px 20px 0;
  }
  .month {
    text-align: center;
    li {
      text-transform: uppercase;
      letter-spacing: 0;
    }
    .arrow {
      color: #5283c4;
      font-size: 12px;
      i {
        font-size: 13px;
        top: 2px;
      }
    }
    .year-month {
      width: 315.5px;
      margin: auto;
      padding: 16px 0 19.5px 0;
      border-bottom: 1px solid #ededed;
      span {
        font-size: 15px;
        font-weight: bold;
        color: #333333;
      }
    }
  }

  .weekdays {
    /*头部星期*/
    width: 315.5px;
    margin: auto;
    font-size: 15px;
    font-weight: Medium;
    padding: 17px 0 15px 0;
    // background-color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    li {
      display: inline-block;
      text-align: center;
    }
  }

  .days {
    /*日期*/
    font-size: 13px;
    padding: 0 0 10px;
    background: #ffffff;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;

    li {
      list-style-type: none;
      width: 14.2%;
      padding: 1%;
      box-sizing: border-box;
      height: 26px;
      margin-top: 10px;
      text-align: center;
      color: #333333;
      .cli {
        position: relative;
        width: 100%;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          /*签到的日期*/
          width: 26px;
          height: 26px;
          position: absolute;
        }
      }
      .cli2{
          img{
            width: 21px;
          }
      }
    }
  }

  .role {
    width: 345px;
    height: 124px;
    margin: auto;
    margin-top: 35.5px;
    text-align: center;
    background: #ffffff;
    overflow: hidden;

    .role-title {
      width: 118.12px;
      height: 22.02px;
      margin: 30px auto 0;

      font-weight: bold;
      font-size: 15px;
      color: #333333;
      background: url(./img/tit-bg.png) no-repeat 100%;
      background-size: 100% 100%;
    }
    .role-content {
      margin-top: 18.5px;
      font-size: 12px;
      font-weight: Medium;
      color: #666666;
    }
  }
}
</style>